var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.96742 6.09002L9.87742 9.00001L6.96742 11.91C6.67492 12.2025 6.67492 12.675 6.96742 12.9675C7.25992 13.26 7.73242 13.26 8.02492 12.9675L11.4674 9.52501C11.7599 9.23251 11.7599 8.76001 11.4674 8.46751L8.02492 5.02502C7.73242 4.73252 7.25992 4.73252 6.96742 5.02502C6.68242 5.31752 6.67492 5.79752 6.96742 6.09002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandMore);
export default __webpack_public_path__ + "static/media/expand-more.632dc872b0625fe7af90e615622d91f7.svg";
export { ForwardRef as ReactComponent };